import { SET_USER_ACCESS, CLEAR_USER_ACCESS } from "../constants/actionTypes";

const initialState = {
  token: "",
  accountName: "",
  userRole: "",
};

const UserAccess = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ACCESS:
      return {
        ...state,
        token: action.payload.token,
        accountName: action.payload.accountName,
        userRole: action.payload.userRole,
        customerID: action.payload.customerID,
        accessID: action.payload.accessID,
        LoginDate: action.payload.LoginDate,
      };
    case CLEAR_USER_ACCESS:
      return {
        ...state,
        token: "",
        accountName: "",
        userRole: "",
        customerID: "",
        accessID: "",
        LoginDate: "",
      };
    default:
      return state;
  }
};

export default UserAccess;
